import { createModel } from '@rematch/core';
import URL from '../../constants/api-constants';
import { RootModel } from '.';
import createBaseMetaFieldsModel from './utils/createBaseMetaFieldsModel';

export const location_meta_fields = createModel<RootModel>()({
  ...createBaseMetaFieldsModel(URL.LOCATION_META_FIELDS),
});
